import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import FrameContentPreview from "@/app/editor/views/FrameContentPreview.vue";
import {editor} from "@/app/editor";
import {ForwardModuleV1} from "@/app/editor/modules/forward/v1/forward_v1";
import GiftPreview from "@/app/editor/views/GiftPreview.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForwardPreview',
  props: {
    index: {}
  },
  setup(__props: any) {


const props = __props
const forward = editor.activity?.modules[props.index] as ForwardModuleV1

return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(`section_${_ctx.index}`)
    }, null, 2),
    (_unref(forward).config.share_local_group_limit.enable || _unref(forward).config.share_timeline_limit.enable || _unref(forward).config.timeline_like_limit.enable)
      ? (_openBlock(), _createBlock(FrameContentPreview, {
          key: 0,
          title: "转发福利"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_typography_title, {
              level: 4,
              style: {"color":"red","margin":"10px 0 0 0"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(forward).config.share_local_group_limit.enable ? `转发到 ${_unref(forward).config.share_local_group_limit.amount}个本地生活群；` : '') + " " + _toDisplayString(_unref(forward).config.share_timeline_limit.enable ? `连续 ${_unref(forward).config.share_timeline_limit.amount} 天分享朋友圈；` : '') + " " + _toDisplayString(_unref(forward).config.timeline_like_limit.enable ? `分享到朋友圈，集齐 ${_unref(forward).config.timeline_like_limit.amount}赞；` : '') + " 完成任意" + _toDisplayString(_unref(forward).config.complete_count) + "项，即可得： ", 1)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(forward).config.gifts, (gift, i) => {
              return (_openBlock(), _createBlock(GiftPreview, {
                key: i,
                gift: gift
              }, null, 8, ["gift"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})